export default __webpack_public_path__ + "static/media/2nd (2).7f6e2f8b.png";